import React, { Component } from 'react'
import { InputText } from 'primereact/inputtext'
import {Button} from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { DossierService } from '../service/DossierService';
import { VilleService } from '../service/VilleService';
import { SessionService } from '../service/SessionService';



export class Depot extends Component {
    
        state = {
        idDossier : null,
        statutDossier : null,
        typeDossier : null,
        idEtudiant : null,
        idSessionCenou : [],
        recipisseDossier : null,
        idTypeCritere : null,
        idCritere : null,
        nomFichier : null,
        libelleTypeCritere : null,
        libelleCritere : null,
        listeDossierCritere : new Array(),
        villes : [],
        selectedVilles : [],
        openSessions: [],
        openSessionVilles: [],
        hasOpenSessions: false,
        permissionDenied: false,
        listeDossierCritereEtudiant : [],
        redirect : false,
        verife : false,
        loading : false,
        initialLoading : true,
        file : null,
        obligatoireTypeCritere : false,
        obligatoireCritere : false,
        dataEtudiant : {},
        dossierEtudiant : [],
        verifeExtensions : [],
        verifeExtension : false,
        verifeTailles : [],
        verifeTaille : false
        }

        constructor(props){

            super(props);
            
            this.dossierService = new DossierService();
            this.villeService = new VilleService();
            this.sessionService = new SessionService();
        }
    
    
    componentDidMount = () => {
        
        const data = localStorage.getItem('user')
        const user = JSON.parse(data)
        this.setState({ initialLoading: true })
        //console.log(user.username)
         // récupérer la liste des villes pour le dépôt (cases à cocher)
            this.villeService.getAll().then(data => {
                console.log(data)
                if(data) this.setState({villes: data}, this.updateOpenSessionVilles)
            }).catch(err => {
                if (err.response && err.response.status === 403) {
                    this.setState({ permissionDenied: true });
                } else {
                    console.log(err);
                }
            })
            // récupérer les sessions et vérifier s'il en existe au moins une OUVERTE de type INSCRIPTION
            this.sessionService.getAll().then(sessions => {
                console.log(sessions)
                if(sessions && Array.isArray(sessions)){
                    const open = sessions.filter(s => {
                        const statut = s.statutSession || null;
                        const type = s.etatSession || null;
                        return statut === 'OUVERT' && type === 'INSCRIPTION';
                    })
                    this.setState({ openSessions: open, hasOpenSessions: open.length > 0 }, this.updateOpenSessionVilles)
                }
            }).catch(err => {
                if (err.response && err.response.status === 403) {
                    this.setState({ permissionDenied: true });
                } else {
                    console.log(err);
                }
            }).finally(() => {
                this.setState({ initialLoading: false })
            })
        this.dossierService.getListeDossierCritere(user.username)
        .then(res => { 
            let idTypeCritere = null, choixCritere = false, choixFichier = false, listeCritere = [], justificatif
            
            res.data.listeDossierCritere.map((dossierCritere, i) => {
                idTypeCritere = dossierCritere.idTypeCritere
                choixCritere = dossierCritere.obligatoire
                justificatif = dossierCritere.justificatif
                listeCritere = dossierCritere.listeCritere
                
                this.state.listeDossierCritere.push({idTypeCritere : idTypeCritere, listeCritere : listeCritere,idCritere : null, choixCritere : choixCritere, choixFichier : choixFichier, justificatif : justificatif, obligatoireTypeCritere : 0, obligatoireCritere : 0, nomFichier : null, fichier : null})
            })
            this.setState({
                dataEtudiant : res.data,
                //idSessionCenou : res.data.idSessionCenou,
                listeDossierCritereEtudiant : res.data.listeDossierCritere,
                verife : true
            })
           
            //console.log(res.data.idSessionCenou)
            //if(res.data.idSessionCenou === null) this.notify5()
        })
        .catch(error => {
            //this.notify4()
            this.notify9()
            console.log(error);
            
        })
        
    }
    
    onFileChange = (event, i) => { 
        let file = event.target.files[0]
        
        
        if(file){
            let extension = file.name.split('.').pop();
            let taille = file.size
            if(extension === "pdf"){

                if(taille <= 3000000 ) {
            
                    this.setState({nomFichier : file.name})
                    this.state.listeDossierCritere[i].nomFichier = file.name
                    const reader = new FileReader()
                    reader.onload = readerEvt => {
                        let binaryString = readerEvt.target.result
                        let fichier = btoa(binaryString)
                        this.setState({file : fichier})
                        this.state.listeDossierCritere[i].fichier = fichier
                    }
                    
                    reader.readAsBinaryString(file)
                    this.state.verifeExtensions[i] = false
                    this.state.verifeTailles[i] = false
                }
                else {
                    this.state.verifeTailles[i] = true
                }
            }
            else {
                this.state.verifeExtensions[i] = true
            }
             
        }
        
    }

    onVilleToggle = (ville) => {
        const selected = Array.from(this.state.selectedVilles);
        const idx = selected.indexOf(ville.idVille);
        if(idx === -1) selected.push(ville.idVille);
        else selected.splice(idx,1);
        this.setState({ selectedVilles: selected }, () => {
            // mettre à jour idVille et sessions correspondantes
            this.setState({ idVille: selected });
            this.updateSessionsForSelectedVilles();
        })
    }

    updateSessionsForSelectedVilles = () => {
        const { selectedVilles, villes } = this.state;
        if(!selectedVilles || selectedVilles.length === 0) {
            this.setState({ idSessionCenou: [] });
            return;
        }
        // extraire directions uniques
        const directions = selectedVilles.map(id => {
            const v = villes.find(x => x.idVille === id);
            return v ? v.idDirection : null;
        }).filter((d, i, arr) => d !== null && arr.indexOf(d) === i);

        // récupérer les sessions pour chaque direction
        const promises = directions.map(d => this.sessionService.getSessionDirection(d).catch(e=>{console.log(e); return []}));
        Promise.all(promises).then(results => {
            const isOpenAndInscription = (s) => {
                if(!s) return false;
                const statut = s.statutSession || s.statut || s.etatSession || s.etat || null;
                const type = s.typeSession || s.type || s.libelleTypeSession || null;
                return statut === 'OUVERT' && type === 'INSCRIPTION';
            }

            let sessionIds = [];
            results.forEach(res => {
                if(Array.isArray(res)){
                    res.forEach(s => {
                        if(isOpenAndInscription(s)){
                            const id = s.idSessionCenou || s.id || s.idSession || s.sessionId;
                            if(id) sessionIds.push(id);
                        }
                    })
                }
                else if(res) {
                    // si l'api renvoie un objet contenant une liste
                    const list = res.listeSession || res.sessions || res.data || [];
                    if(Array.isArray(list)){
                        list.forEach(s => { if(isOpenAndInscription(s)){ const id = s.idSessionCenou || s.id || s.idSession || s.sessionId; if(id) sessionIds.push(id);} })
                    }
                }
            })
            // rendre unique
            sessionIds = sessionIds.filter((v,i,a) => a.indexOf(v) === i);
            this.setState({ idSessionCenou: sessionIds })
        })
    }

    updateOpenSessionVilles = () => {
        const { openSessions, villes } = this.state;
        if(!openSessions || openSessions.length === 0 || !villes || villes.length === 0){
            this.setState({ openSessionVilles: [] });
            return;
        }
        const directions = openSessions.map(s => s.idDirection || s.idDirectionRegionale || s.id || null).filter((d,i,a) => d !== null && a.indexOf(d) === i);
        const openVilles = villes.filter(v => directions.indexOf(v.idDirection) !== -1);
        this.setState({ openSessionVilles: openVilles });
    }

    /*onCritereChoix = (dossierCritere, i) => {
        dossierCritere.listeCritere.map(critere => {
            if(critere.obligatoire){
                this.state.listeDossierCritere[i].obligatoireCritere = 1
            }
            else this.state.listeDossierCritere[i].obligatoireCritere = 2
        } )

    }*/
     
    DepotDossier = () => { 
    
        let verifeCritere = false, verifeFichier = false, verifeExt = false, verifeTaille = false
       
        this.state.listeDossierCritere.map((dossierCritere, i) => {
            if(this.state.verifeExtensions[i]) verifeExt = true
            if(this.state.verifeTailles[i]) verifeTaille = true
            if(dossierCritere.choixCritere && dossierCritere.choixFichier){
                if(!dossierCritere.idCritere) verifeCritere = true;
                if(!dossierCritere.fichier) verifeFichier = true;
            }
            else if(dossierCritere.choixCritere && !dossierCritere.choixFichier) {
                if(!dossierCritere.idCritere) verifeCritere = true;
            }
            else if(!dossierCritere.choixCritere && dossierCritere.choixFichier) {
                if(dossierCritere.idCritere) {
                    if(!dossierCritere.fichier) verifeFichier = true;
                }
            }
        }
    )
    //console.log(verifeExt)
    //console.log(verifeCritere)
    //console.log(verifeFichier)
     
        if(!this.state.selectedVilles || this.state.selectedVilles.length === 0){
            this.notify10();
            return;
        }
        else if(verifeCritere){
            this.notify2();
        }
        else if(verifeFichier){
            this.notify8();
        }
        else if(verifeExt){
            this.notify6();
        }
        else if(verifeTaille){
            this.notify7();
        }

        else {
        const villesSelectionnees = this.state.selectedVilles
            .map(idVille => {
                const ville = this.state.villes.find(v => v.idVille === idVille);
                return ville ? (ville.nomVille || ville.libelleVille) : null;
            })
            .filter(Boolean);

        const newDepot = {
            idDossier : this.state.idDossier,
            statutDossier : this.state.statutDossier,
            typeDossier : this.state.typeDossier,
            listeVilleDepot : villesSelectionnees,
            listeDossierCritere : this.state.listeDossierCritere,
            idEtudiant : this.state.dataEtudiant.idEtudiant,
            ine : this.state.dataEtudiant.ine, 
            nomEtudiant : this.state.dataEtudiant.nomEtudiant,
            prenomEtudiant : this.state.dataEtudiant.prenomEtudiant,
       }
       
       console.log(newDepot)
       this.setState({loading : true})
        this.dossierService.depot(newDepot)
        .then(res => { 
            this.setState({redirect : true, loading : false})
            this.notify();
        })
        .catch(error => {
            console.log(error);
            this.notify3()
            this.setState({ loading : false})
        })
        }
      
    }

      loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )
      notify = () => toast.success('Dépôt de dossier effectué !', {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify2 = () => toast.error('Renseigner les champs obligatoire !', {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify3 = () => toast.error("Vous disposez dejà d'un dossier !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify4 = () => toast.error("Vous n’êtes pas autorisé à faire un dépôt car votre ville d'orientation ne dispose pas de cités universitaire pour le moment !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify5 = () => toast.error("La session de dépôt est fermée !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify6 = () => toast.error("Veuillez renseigner que des fichier pdf !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify7 = () => toast.error("Veuillez renseigner des fichiers avec une taille inférieur ou egal à 3Mo(3000Ko) !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify8 = () => toast.error("Veuillez Joindre des fichiers aux critères justifiable !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify9 = () => toast.error("Une erreur interne est servenue !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    notify10 = () => toast.error("Veuillez choisir au moins une ville avant de déposer le dossier !", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    
    render() {
        
        //console.log(this.state.listeDossierCritere)
        //console.log(this.state.dataEtudiant)
        //console.log(this.state.dataEtudiant.listeDossierCritere)
        //console.log(this.state.listeDossierCritere[0])
        /*this.state.listeDossierCritereEtudiant.map(dossierCritere => {
            this.state.listeDossierCritere.push({idCritere : null, nomFichier : null, fichier : null})
        })*/
        
        
        return (
            <div className="">
                {this.state.permissionDenied ?
                    <div className="p-lg-12 p-grid">
                        <div className="p-lg-12 contenair " id="slideshow" style={{textAlign : ""}}>
                            <div id="slider" style={{backgroundColor : "#f8d7da", padding : 5}}>
                                <p style={{fontWeight : "bold", fontStyle : "italic", fontSize : 16, color : "#721c24", textAlign : "center", marginTop : 10}}>
                                    Votre compte étudiant ne dispose pas des droits nécessaires pour consulter les sessions et les villes de dépôt.
                                </p>
                            </div>
                        </div>
                    </div>
                : this.state.initialLoading ?
                    <div className="p-lg-12 p-grid">
                        <div className="p-lg-12 contenair " id="slideshow" style={{textAlign : ""}}>
                            <div id="slider" style={{backgroundColor : "#d1ecf1", padding : 5, textAlign : "center"}}>
                                {this.loadingSpinner("spin", "black")}
                            </div>
                        </div>
                    </div>
                : this.state.hasOpenSessions ?
                
                    this.state.loading ? 
                        this.loadingSpinner("spin","black")
                        :
                        <>
                         <div className="p-grid">
                            <div className="p-lg-12 contenair " id="slideshows" style={{textAlign : ""}}>
                                <div id="slider" style={{backgroundColor : "#d1ecf1", padding : 5}}>
                                    <h4 style={{textAlign : "center"}}>Dépôt de dossier pour la cité universitaire</h4>
                                    <p style={{fontWeight : "bold", fontStyle : "italic", fontSize : 16, color : "red", textAlign : "center", marginTop : 10}}>
                                    Vous aurez plus de chance en apportant les justificatifs des critères que vous aurez choisi ! <br/>
                                    certains critères sont forcement justifiables en joignant des fichiers.<br/>
                                    NB : Veuillez renseigner uniquement que des fichiers PDF, la taille de chaque fichier ne doit pas depasser 3Mo, <br/> les noms des fichiers ne doivent pas contenir des caractères accentués
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="p-lg-12 p-grid">
                                {this.state.redirect ?
                                    <Link style={{marginLeft :"20px"}} to="/tableau-de-bord">Consulter votre tableau de bord</Link>
                                        :
                                        ''
                                }
                        </div>
                        <ToastContainer
                            position="top-right"
                            autoClose={10000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    <ToastContainer />
                        
                            {this.state.verife ?
                            <>
                            <form className="p-fluid">
                                <div className=" card " >
                                    <div className="p-grid">
                                        <div className="p-lg-1"> 
                                            <label>INE</label>
                                            <InputText value={this.state.dataEtudiant.ine || ""} disabled type="text" />
                                        </div>
                                        <div className="p-lg-2" style={{marginTop : -3.5}}> 
                                            <label>Nom</label>
                                            <InputText value={this.state.dataEtudiant.nomEtudiant || "" }  disabled  type="text" />
                                        </div>
                                        <div className="p-lg-2" style={{marginTop : -3.5}} > 
                                            <label>Prénom</label>
                                            <InputText value={this.state.dataEtudiant.prenomEtudiant || ""}  disabled  type="text" />
                                        </div>
                                        <div className="p-lg-1"> 
                                            <label>Sexe</label>
                                            <InputText value={this.state.dataEtudiant.sexeEtudiant || ""}  disabled  type="text" />
                                        </div>
                                        <div className="p-lg-1"> 
                                            <label>Date de naiss.</label>
                                            <InputText value={this.state.dataEtudiant.dateNaissance || ""}  disabled  type="text" />
                                        </div>
                                        <div className="p-lg-2" style={{marginTop : -3.5}}> 
                                            <label>Lieu de naiss.</label>
                                            <InputText value={this.state.dataEtudiant.lieuNaissance || ""}  disabled  type="text" />
                                        </div>
                                
                                        {/* <div className="p-lg-1"> 
                                            <label>Type pays</label>
                                            <InputText value={this.state.dataEtudiant.typePays || ""}  disabled  type="text" />
                                        </div>
                                        <div className="p-lg-1"> 
                                            <label>Serie BAC</label>
                                            <InputText value={this.state.dataEtudiant.serieBac || ""}  disabled  type="text" />
                                        </div>
                                        <div className="p-lg-1"> 
                                            <label>Moyenne BAC</label>
                                            <InputText value={this.state.dataEtudiant.moyenneBac}  disabled  type="text" />
                                        </div> */}
                                    </div>
                                </div>
                            </form>
                            {this.state.hasOpenSessions && this.state.openSessionVilles && this.state.openSessionVilles.length > 0 ? (
                            <div className=" card " style={{marginTop:10}}>
                                <div className="p-grid">
                                    <div className="p-lg-12">
                                        <label style={{fontWeight: 'bold'}}>Villes des sessions ouvertes</label>
                                    </div>
                                    <div className="p-lg-12" style={{marginBottom: 10}}>
                                        <span style={{color: '#0d6efd', fontStyle: 'italic'}}>Sélectionnez les villes dans lesquelles vous souhaitez la cité universitaire.</span>
                                    </div>
                                    <div className="p-lg-12">
                                        {this.state.openSessionVilles
                                            .filter((ville) => (ville.nomVille || ville.libelleVille || '').toUpperCase() !== 'OUAGADOUGOU2')
                                            .map((ville) => {
                                                const nomVille = (ville.nomVille || ville.libelleVille || '').toUpperCase() === 'SAABA'
                                                    ? 'SAABA(THOMAS SANKARA)'
                                                    : (ville.nomVille || ville.libelleVille);
                                                return (
                                                    <div key={ville.idVille} className="p-col-3" style={{padding:5}}>
                                                        <label>
                                                            <input type="checkbox" checked={this.state.selectedVilles.indexOf(ville.idVille) !== -1} onChange={() => this.onVilleToggle(ville)} /> {nomVille}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                            ) : (
                            <div className=" card " style={{marginTop:10}}>
                                <div className="p-grid">
                                    <div className="p-lg-12">
                                        <label style={{fontWeight: 'bold'}}>Choisir la/les ville(s) pour le dépôt</label>
                                    </div>
                                    <div className="p-lg-12" style={{marginBottom: 10}}>
                                        <span style={{color: '#0d6efd', fontStyle: 'italic'}}>Sélectionnez les villes dans lesquelles vous souhaitez la cité universitaire.</span>
                                    </div>
                                    <div className="p-lg-12">
                                        {this.state.villes && this.state.villes.length > 0 ? (
                                            this.state.villes
                                                .filter((ville) => (ville.nomVille || ville.libelleVille || '').toUpperCase() !== 'OUAGADOUGOU2')
                                                .map((ville) => {
                                                    const nomVille = (ville.nomVille || ville.libelleVille || '').toUpperCase() === 'SAABA'
                                                        ? 'SAABA(THOMAS SANKARA)'
                                                        : (ville.nomVille || ville.libelleVille);
                                                    return (
                                                        <div key={ville.idVille} className="p-col-3" style={{padding:5}}>
                                                            <label>
                                                                <input type="checkbox" checked={this.state.selectedVilles.indexOf(ville.idVille) !== -1} onChange={() => this.onVilleToggle(ville)} /> {nomVille}
                                                            </label>
                                                        </div>
                                                    );
                                                })
                                        ) : (
                                            <div className="p-lg-12">Chargement des villes...</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            )}
                            <form className="p-fluid">
                                <div className=" card " >
                                    { this.state.listeDossierCritereEtudiant.map((dossierCritere,i) => 
                                        
                                        
                                        <div key={i} className="p-grid">
                                            <div className="p-lg-4"></div>
                                            <div className="p-lg-2"> 
                                                <label>
                                                {
                                                    dossierCritere.obligatoire
                                                    ?
                                                    <span>{dossierCritere.libelleTypeCritere} <span style={{color : "red"}}>*</span> </span>
                                                    :

                                                    dossierCritere.libelleTypeCritere
                                                    
                                                }
                                            </label>

                                            <Dropdown optionLabel="libelleCritere" optionValue="idCritere" value={this.state.listeDossierCritere[i].idCritere}  options={dossierCritere.listeCritere} 
                                                onChange={(e)=>{
                                                    this.setState({idCritere :  e.value})
                                                    this.state.listeDossierCritere[i].idCritere  = parseInt(e.value)
                                                    this.state.listeDossierCritere[i].listeCritere.map(critere => { 
                                                        if(critere.idCritere === parseInt(e.value)){
                                                            //console.log(critere.obligatoire)
                                                            //console.log(critere.libelleCritere)
                                                            this.state.listeDossierCritere[i].choixFichier = critere.obligatoire
                                                        }
                                                     } )
                                                }} 
                                            />
                                        </div>
                                        {dossierCritere.justificatif ?
                                        <div className="p-lg-2"> 
                                            
                                                <label>Justificatif {dossierCritere.libelleTypeCritere}</label>
                                                <input type="file" 
                                                    onChange={(e)=>{
                                                     this.onFileChange(e,i)
                                                    }
                                                }
                                                />
                                                {this.state.verifeExtensions[i] && <br/> && <span style={{color : "red"}}>vous devriez renseigner un fichier pdf</span>}
                                                {this.state.verifeTailles[i] && <br/> && <span style={{color : "red"}}>la taille du fichier ne doit pas depasser 3Mo</span>}
                                        </div>
                                        :
                                        ""
                                        }
                                        
                                        </div>
                                        )}
                                        <div className="p-lg-12">
                                            <div className="p-grid"> 
                                                <div className="p-lg-4"> </div>
                                                <div className="p-lg-2 ">
                                                    <Button  type="button" onClick={this.DepotDossier} label="Deposer" icon="pi pi-check"/>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                
                            </form>
                            </>
                            :
                            ""
                            }
                            
                     </>
                        
                     
                    : 
                    <div className="p-lg-12 p-grid">
                        <div className="p-lg-12 contenair " id="slideshow" style={{textAlign : ""}}>
                            <div id="slider" style={{backgroundColor : "#d1ecf1", padding : 5}}>
                                <p style={{fontWeight : "bold", fontStyle : "italic", fontSize : 16, color : "red", textAlign : "center", marginTop : 10}}>
                                    Aucune session ouverte pour les dépôts (OUVERT & INSCRIPTION)
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                    </div>		
        )
    }
}

export default Depot
